import type { FC, ReactNode } from 'react'
import type { GetStaticProps } from 'next'
import type { ProjectSummary, Testimonial } from '@/types'

import { getProjectSummaries, getTestimonials } from '@/lib/portfolio'
import { Layout } from '@/components/generals/layout'
import { Seo } from '@/components/generals/seo'
import { About } from '@/components/landing/about'
import { Contact } from '@/components/landing/contact'
import { Hero } from '@/components/landing/hero'
import { Marquee } from '@/components/landing/marquee'
import { Process } from '@/components/landing/process'
import { Services } from '@/components/landing/services'
import { Testimonials } from '@/components/landing/testimonials'
import { WorkSection } from '@/components/landing/work-section'

interface HomeProps {
    projects: ProjectSummary[]
    testimonials: Testimonial[]
}

export const getStaticProps: GetStaticProps<HomeProps> = async () => {
    try {
        const [projects, testimonials] = await Promise.all([
            getProjectSummaries(),
            getTestimonials()
        ])

        return {
            props: { projects, testimonials },
            revalidate: 60
        }
    }
    catch (error) {
        console.error('Could not load portfolio content:', error instanceof Error ? error.message : error)

        return {
            props: { projects: [], testimonials: [] },
            revalidate: 10
        }
    }
}

const Home: FC<Partial<HomeProps>> = ({ projects = [], testimonials = [] }): ReactNode => {
    return (
        <Layout>
            <Seo />

            <Hero />
            <Marquee />
            <WorkSection projects={projects} />
            <Services />
            <Process />
            <About />
            <Testimonials testimonials={testimonials} />
            <Contact />
        </Layout>
    )
}

export default Home
